import { Box, freddyTheme, ListItem } from '@coolblue-development/freddy';
import { Circle } from '@coolblue-development/icons';
import { IconWithText } from '@coolblue-development/next-patterns/client';
import { ReactNode } from 'react';

export default function StyledListItem({ children }: { children: ReactNode }) {
  return (
    <ListItem>
      <IconWithText
        description={children}
        icon={
          <Box sx={{ svg: { marginBottom: freddyTheme.spacing[100] } }}>
            <Circle size={4} />
          </Box>
        }
        alignItems='flex-start'
      />
    </ListItem>
  );
}
